import { render } from "./Authority.vue?vue&type=template&id=631ece1e&scoped=true&ts=true"
import script from "./Authority.ts?vue&type=script&lang=ts"
export * from "./Authority.ts?vue&type=script&lang=ts"

import "./Authority.scss?vue&type=style&index=0&id=631ece1e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-631ece1e"]])

export default __exports__